const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const Link = require("../core/view/Link");
const EmailInput = require("./EmailInput");
const URLMake = require("../../shared/URLMake");
const ScrollUtil = require("../core/util/ScrollUtil");
const AssetsUtil = require("../core/util/AssetsUtil");
const CopyTable = require("./data/CopyTable");

const bottomBarInfo = {
	noBottomBar: ["office.classtag"],
	simpleBar: ["office.checkout", "office.redeemSubscription"],
};

const styles = require("./styles/BottomBar.css");

module.exports = createReactClass({
	displayName: "OfficeBottomBar",

	propTypes: {
		noJS: PT.bool,
		page: PT.object.isRequired,
	},

	shouldComponentUpdate: function(nextProps, nextState) {
		return this.props.page.name !== nextProps.page.name;
	},

	linkPageScroll: function() {
		ScrollUtil.scrollTo("top");
	},

	render: function() {
		const pageName = this.props.page.name;
		if (_.includes(bottomBarInfo.noBottomBar, pageName)) {
			return null;
		}
		const {menu, socialMedia} = CopyTable.getBottomBarCopy();

		const menuCols = menu.map(m => {
			const items = m.items.map((sub, i) => {
				let linkTo = m.links[i];
				let clickAction = null;
				const isExternal =
					_.includes(linkTo, "artofproblemsolving") ||
					_.includes(linkTo, "aopsacademy") ||
					_.includes(linkTo, "help.beastacademy");
				if (linkTo === "home") {
					linkTo = URLMake.forOffice();
					clickAction = this.linkPageScroll;
				}
				return (
					<div key={sub}>
						<Link
							className={styles.menuItem}
							to={linkTo}
							clickAction={clickAction}
							isExternal={isExternal}
							isNewTab={isExternal}
						>
							{sub}
						</Link>
					</div>
				);
			});
			return (
				<div className={"baBottomBarMenuCol"} key={m.title}>
					<div className={"baBottomBarMenuTitle"}>{m.title}</div>
					{items}
				</div>
			);
		});
		const endYear = new Date().getFullYear();

		const signUp = !this.props.noJS && (
			<div className={styles.signup}>
				<div className={"baBottomBarMenuTitle"}>
					subscribe for news and updates
				</div>
				<EmailInput
					extraClass={styles.input}
					backgroundType="bottomBar"
					size="smaller"
					sectionName="bottomUpdates"
				/>
			</div>
		);

		const icons = socialMedia.icons.map((icon, i) => (
			<Link
				key={icon}
				to={socialMedia.links[i]}
				isExternal={true}
				isNewTab={true}
				className={styles.smIcon}
			>
				<img src={AssetsUtil.getBrandIcon(icon)} />
			</Link>
		));

		const external = (
			<div className={"baBottomBarMenuCol"}>
				<div className={"baBottomBarMenuTitle"}>Follow us</div>
				<div className={styles.socialMedia}>{icons}</div>
			</div>
		);

		let mainClass = styles.main;
		if (_.includes(bottomBarInfo.simpleBar, pageName)) {
			mainClass += " " + styles.simplerBar;
		}

		const copyright = (
			<div className={styles.copyright}>
				© {endYear} AoPS Incorporated
				<div className={styles.termsPrivacy}>
					<Link to={URLMake.forAbout()} isNewTab={true}>
						About Us
					</Link>
					{" • "}
					<Link to={URLMake.forContact()} isNewTab={true}>
						Contact
					</Link>
					{" • "}
					<Link to={URLMake.forPrivacy()} isNewTab={true}>
						Privacy
					</Link>
					{" • "}
					<Link to={URLMake.forTerms()} isNewTab={true}>
						Terms
					</Link>
				</div>
			</div>
		);

		return (
			<div className={mainClass}>
				<div className={styles.container}>
					<div className={styles.logos}>
						<Link to={URLMake.forOffice()}>
							<img
								src={AssetsUtil.getLogo("aops-ba-white")}
								className={styles.mainLogo}
							/>
						</Link>
					</div>
					<div className={styles.content}>
						<div className={styles.mainLinks}>{menuCols}</div>
						{external}
						{signUp}
					</div>
					{copyright}
				</div>
			</div>
		);
	},
});
